import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '~gql';

export const PUBLIC_USER = graphql(`
  query PublicUser($id: ID!) {
    publicUser(userIDoUsername: $id) {
      id
      username
      fullName
      isVerified
      avatarUrl
      age
      gender
      relationshipStatus
      bio
      personality {
        code
        description
      }
      languages {
        code
        nativeName
      }
      interests {
        id
        name
      }
      spotifyArtists {
        id
        name
        imageUrl
      }
    }
  }
`);

export type PublicUserData = ResultOf<typeof PUBLIC_USER>;
export type PublicUserVars = VariablesOf<typeof PUBLIC_USER>;
export type PublicProfile = NonNullable<PublicUserData['publicUser']>;
export type PublicLanguage = PublicProfile['languages'][number];
export type PublicInterest = PublicProfile['interests'][number];
export type PublicSpotifyArtist = PublicProfile['spotifyArtists'][number];
